import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { connect } from 'react-redux';
import { change } from 'redux-form';

import { injectIntl } from 'react-intl';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from 'react-dates/lib/css/_datepicker.css';
import { isRTL } from '../../../../helpers/formatLocale';

import messages from '../../../../locale/messages';

class DateRange extends React.Component {
  static propTypes = {
    onChange: PropTypes.any,
    numberOfMonths: PropTypes.number,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
    };
  }

  onDatesChange = ({ startDate, endDate }) => {
    const { change } = this.props;
    change('PayoutManagement', 'startDate', startDate);
    change('PayoutManagement', 'endDate', endDate);
    if (startDate != null && endDate != null) {
      change('PayoutManagement', 'dates', `'${moment(startDate).format("YYYY-MM-DD")}' AND '${moment(endDate).format("YYYY-MM-DD")}'`);
    } else {
      change('PayoutManagement', 'dates', null);
    }
  }

  onFocusChange = (focusedInput) => {
    this.setState({ focusedInput });
  }

  render() {
    const { focusedInput } = this.state;
    const { numberOfMonths, locale, dates, startDate, endDate } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <DateRangePicker
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          numberOfMonths={numberOfMonths}
          startDatePlaceholderText={formatMessage(messages.startDateLabel)}
          endDatePlaceholderText={formatMessage(messages.endDateLabel)}
          hideKeyboardShortcutsPanel
          readOnly
          showClearDates
          startDateId={'startDateId'}
          endDateId={'endDateId'}
          transitionDuration={0}
          anchorDirection={isRTL(locale) ? 'right' : 'left'}
          isRTL={isRTL(locale)}
          isOutsideRange={() => false}
        />
      </div>
    );
  }
}

const mapState = state => ({
  locale: state.intl.locale,
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(DateRange)));